import { useEffect } from "react";

export const useLoadsPageEffects = ({ currentPage, filters, loadLoads, loadSharedResources, pageSize, search, setCurrentPage, totalLoads }) => {
  useEffect(() => {
    loadSharedResources();
  }, [loadSharedResources]);

  useEffect(() => {
    loadLoads();
  }, [loadLoads]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, filters.customer_id, filters.status.join("|"), filters.shipment_direction, filters.truck_id, filters.trailer_id, filters.driver_id, filters.start_date, filters.end_date, filters.sort_by, filters.sort_dir, pageSize, setCurrentPage]);

  useEffect(() => {
    const totalPages = Math.max(1, Math.ceil(totalLoads / pageSize));
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, pageSize, setCurrentPage, totalLoads]);
};